export default __webpack_public_path__ + "static/media/videoPlaceholder.6ebd0ccb.svg";